<template>
    <v-dialog max-width="50%" v-model="dialog">
        <v-card min-width="50%">

            <v-card-actions class="ma-0 pa-0">
                <v-spacer></v-spacer>
                <v-btn icon class="ma-2 pa-0" color="red" @click="onClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-actions>

            <v-card-actions dense class="ma-0 pa-0">
                <v-spacer></v-spacer>
                <template v-for="(audience, index)  in getAudiences()" >
                    <v-checkbox
                            :key="audience.name"
                            color="blue"
                            :style="{'margin-left': (index != 0 ? 10 : 0) + 'px', 'margin-top':'-10px', 'margin-bottom':'10px'}"
                            v-model="selected[audience.name]"
                            :label="audience.name.toUpperCase()"
                            :value="audience.name"
                            @change="check(audience.name)"
                    ></v-checkbox>
                </template>
                <v-spacer></v-spacer>
            </v-card-actions>

            <v-card-actions dense class="ma-0 pa-0">
                <v-spacer></v-spacer>
                <template v-for="(audience, index)  in getCustomAudiences()" >
                    <v-checkbox
                            :key="audience.name"
                            color="red"
                            :style="{'margin-left': (index != 0 ? 10 : 0) + 'px', 'margin-top':'-10px', 'margin-bottom':'20px'}"
                            v-model="selected[audience.name]"
                            :label="audience.name.toUpperCase()"
                            :value="audience.name"
                            @change="check(audience.name)"
                    ></v-checkbox>
                </template>
                <v-spacer></v-spacer>
            </v-card-actions>

            <v-card-actions style="margin-top: -25px">
                <v-spacer></v-spacer>
                <v-btn
                        :loading="buttonLoading"
                        elevation="0"
                        :disabled="disabledDeploy"
                        class="ma-2 white--text"
                        color="blue"
                        @click="onPressDeploy">DEPLOY
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>

import {MapBackendUtils} from "@/modules/mmaps/database/MapBackendUtils";
import {AudienceTestStoreUtils} from "@/modules/maudiences/database/AudienceTestStoreUtils";

export default {
    name: "m-maps-set-audience-popup",
    props: {},
    data: () => ({
        dialog: false,
        config: null,
        buttonLoading: false,
        selected:{},
    }),
    computed: {
        disabledDeploy(){
            return this.selected.length == 0
        },
    },
    methods: {
        getAudiences(){
            return AudienceTestStoreUtils.getAudiences();
        },
        getCustomAudiences(){
            return AudienceTestStoreUtils.getCustomAudiences();
        },
        check(name){},
        show(map) {

            this.map = map
            this.dialog = true

            this.selected = {}

            var parced = map.aud.split(',');
            // console.log("parced:  ",parced);
            for (let i = 0; i < parced.length; i++) {
                this.selected[parced[i]] = parced[i];
            }
        },
        onClose() {
            this.dialog = false
            this.buttonLoading = false
        },
        onPressDeploy() {
            this.buttonLoading = true
            let data = []

            Object.keys(this.selected).forEach((k) => this.selected[k] == null && delete this.selected[k]);
            var array = Object.keys(this.selected);
            var parced = array.join(",");
            data.push({name: this.map.name, aud:parced})

            if (parced.length != 0){
                MapBackendUtils.setMapAudience(data)
                .then(() => {
                    this.buttonLoading = false
                    this.dialog = false
                    this.$notify({title: 'Map audiences successfully updated!', text: "", type: "succes"});
                })
                .catch((error) => {
                    this.buttonLoading = false
                    this.dialog = false
                    this.$notify({title: 'Map audiences updated failed!', text: error, type: "error"});
                })
            }else{
                this.dialog = false
            }

        }
    }
}
</script>

<style scoped>
</style>